export default class Duration {
    durationAsDecimal: number;
    years: number;
    months: number;
    numerator: number;
    denominator: number;

    constructor(durationAsDecimal: number, years: number, months: number, numerator: number, denominator: number) {
        this.durationAsDecimal = durationAsDecimal;
        this.years = years;
        this.months = months;
        this.numerator = numerator;
        this.denominator = denominator;
    }

    public hasFraction(): boolean {
        return this.months != 0;
    }

    public isNonZeroButLessThanOneYear(): boolean {
        return this.durationAsDecimal > 0 && this.durationAsDecimal < 1;
    }
}
